import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import * as CommonUI from "components";
import SelectDeliveryAddress from "components/checkout/SelectDeliveryAddress";
import OrderPlaced from "components/checkout/OrderPlaced";
import { useLang, useCustomHistory } from "hooks";
import * as Actions from "store/actions";
import useTrackOrder from "features/hooks/useTrackOrder";
import { ValidateGeoLocation } from "utils/Utils";
import { handleLocalStorage } from "utils/storage";
import { getAreaCityAndCountry } from "utils/googleGeoCode";
import SlideInLayout from "components/layouts/SlideInLayout";
import C from "Constants";

export const CheckoutErrorModal = (props) => {
  const dispatch = useDispatch();
  const {currentPaymentMethod} = useSelector((state) => state.AppReducer);
  const { error, errorModaL } = useSelector((rstate) => rstate.errorSlice);
  const handleErrorModalClose = () => {
    if(props?.selectedPaymentType === C.WALLET.NEW_CARD && ([C.PAYBY, C.AFS_PAYMENT].includes(currentPaymentMethod))){
      if(props?.resetState){
        props?.resetState?.(C.WALLET.NEW_CARD);
        dispatch(Actions.AppAction.setCurrentPaymentMethod(null));
      }
    }
    dispatch(Actions.ErrorAction.setErrorModal(false));
  }
  return (
    <CommonUI.CustomModal
        open={errorModaL}
        reduxAction={handleErrorModalClose}
        bodyclasses="flex"
        overlayClasses="fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40"
      >
        <CommonUI.ErrorModal
          reduxAction={handleErrorModalClose}
          message={error}
        />
      </CommonUI.CustomModal>
  )
}

function CheckoutModals(props) {
  const {
    changeAddressModal,
    setChangeAddressModal,
    addressList,
    deleteSlectedAddress,
  } = props;

  const params = useParams();
  const dispatch = useDispatch();
  const { currentLang } = useLang();
  const router = useCustomHistory();
  const { placedOrder } = useSelector((state) => state.order);
  const { outletBasedSelectedStoreArea } = useSelector((state) => state.store);
  const { DomainType } = useSelector((state) => state.AppReducer);
  const { orderSuccess } = useSelector((state) => state.NotPersist);
  const { isGeoLocationAdded, temporarymapAddress, temporaryuserLocation } =
    useSelector((state) => state.DeliveryAddressReducer);
  const trackOrder = useTrackOrder({ placedOrder });

  const goToGoogleMapScreen = () => {
    const mapPage = "/store/checkout/map-address";
    const refinePage = "/store/checkout/add-delivery-address";
    if (
      ValidateGeoLocation(
        isGeoLocationAdded,
        temporarymapAddress,
        temporaryuserLocation
      )
    ) {
      router(refinePage, `/${params?.domainName}${refinePage}`, DomainType);
    } else {
      router(mapPage, `/${params?.domainName}${mapPage}`, DomainType);
    }
  };
  const setAddress = async (address) => {
    dispatch(Actions.DeliveryAddressAction.setDeliveryAddress(address));
    handleLocalStorage.setItem("deliveryAddress", address);
    setChangeAddressModal(false);
    if (
      outletBasedSelectedStoreArea?.mappedAreaType === "DISTANCE" &&
      address?.coordinates?.lat &&
      address?.coordinates?.lng &&
      outletBasedSelectedStoreArea?.areaName
    ) {
      const lat = address?.coordinates?.lat;
      const lng = address?.coordinates?.lng;
      const storeAreaName = await getAreaCityAndCountry(lat, lng, currentLang);
      dispatch(Actions.StoreAction.setDistanceBasedAreaName(storeAreaName));
    }
  };

 

  return (
    <>
      <CheckoutErrorModal {...props} />
      <SlideInLayout
        open={changeAddressModal}
        handleClose={()=>setChangeAddressModal(false)}
        hideOutsideCloseButton
        showHeader
        headerTitle={"Select Delivery Address"}
        showHeaderCloseButton
        container={{
          style:{
          maxHeight:"70vh",
          height:"fit-content"  
          }
        }}
      >
        <SelectDeliveryAddress handleAddressClick={goToGoogleMapScreen}>
         <CommonUI.SaveAddressesList
            savedAddresses={addressList}
            deleteSlectedAddress={deleteSlectedAddress}
            setAddress={setAddress}
            isNewU={true}
          />
        </SelectDeliveryAddress>
        {/* <br/>
        <br/>
        <br/> */}
        <br/>
          {/* <div className="sticky bottom-0 bg-dark-blue-100 p-4">
            <CustomButton>
              <TranslationText text={"Confirm"} />
            </CustomButton>
          </div> */}
      </SlideInLayout>
      <CommonUI.CustomModal
        open={orderSuccess}
        reduxAction={Actions.NotPersistAction.toggleOrderPlaceModel(false)}
        bodyclasses="flex"
        overlayClasses="fixed overflow-y-auto h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40 border-sc"
      >
        <OrderPlaced {...{ trackOrder }} />
      </CommonUI.CustomModal>
    </>
  );
}

export default CheckoutModals;
